module.exports = __webpack_public_path__ + "static/media/Zoom_In.18183a0b.svg";